import React from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'react-intl';

import { RFFFieldErrorWrapper } from 'common/components';
import InputNumber from 'common/components/InputNumber';
import LocalizedNumber from 'common/components/LocalizedNumber';
import { useOfferingMenuPermissionsContext } from 'modules/shared-menu/contexts/OfferingMenuPermissionsContext';

import { BaseField } from './types';
import { FormRowRenderer } from '../FormRowRenderer';
import { DisplayText, StyledInputContainer } from '../OfferDetailsFormFields.styles';
import { BasicDetails } from '../types';

type AlcoholPercentageProps = BaseField & {
  handleRestrictedPropertyChange: ({
    productHierarchyLevelId,
    alcoholPercentage,
  }: {
    productHierarchyLevelId?: string | null | undefined;
    alcoholPercentage?: string | number | undefined;
  }) => void;
};

export const AlcoholPercentage = ({ sidePanelMode, offer, handleRestrictedPropertyChange }: AlcoholPercentageProps) => {
  const menuPermissions = useOfferingMenuPermissionsContext();
  const intl = useIntl();

  const previewComponent = (
    <DisplayText>
      <LocalizedNumber
        value={Number(offer?.alcohol_percentage) / 100}
        options={{
          style: 'percent',
          maximumFractionDigits: 2,
        }}
      />
    </DisplayText>
  );

  const editComponent = (
    <Field<BasicDetails['alcoholPercentage']> name="alcoholPercentage">
      {field => (
        <RFFFieldErrorWrapper field={field}>
          {input => (
            <StyledInputContainer>
              <InputNumber
                {...input}
                onChange={value => {
                  handleRestrictedPropertyChange({
                    alcoholPercentage: value,
                  });
                  input.onChange(value);
                }}
                suffixText="%"
                decimals={1}
              />
            </StyledInputContainer>
          )}
        </RFFFieldErrorWrapper>
      )}
    </Field>
  );

  return (
    <FormRowRenderer
      hasContentEditPermission={menuPermissions.contentEdit}
      label={intl.formatMessage({ id: 'menu-item.alcoholPercentage' })}
      previewComponent={previewComponent}
      editComponent={editComponent}
      sidePanelMode={sidePanelMode}
      offer={offer}
    />
  );
};
